import { useIntl } from "react-intl";
import { Field, useFormState } from "react-final-form";
import { connect } from "react-redux";
import Section from "../../../common/section";
import { DropdownInput, TextInput } from "../../../common/fields";
import * as Validations from "../../../common/form/validator";
import FileUpload from "../../../common/fileUpload";
import * as GlobalConstants from "../../../../constants/GlobalConstants";

export const CertificateDetailForm = ({
  disabled = false,
  onTemplateUpload,
  templateFileName,
  uploading,
  progress,
  uploadDetails,
  onClear,
}) => {
  const intl = useIntl();
  const formState = useFormState();
  return (
    <div className="flex flex-column gap-4">
      <Section title="identity">
        <div className="grid">
          <div className="col-12 md:col-6 lg:col-4">
            <Field
              name="name"
              disabled={disabled}
              component={TextInput}
              type="text"
              label={intl.formatMessage({
                id: "name",
              })}
              placeholder={intl.formatMessage({
                id: "name",
              })}
              required
              validate={Validations.composeValidators(Validations.required)}
            />
          </div>
          <div className="col-12 md:col-6 lg:col-4">
            <Field
              name="orientation"
              disabled={disabled}
              component={DropdownInput}
              type="text"
              label={intl.formatMessage({
                id: "orientation",
              })}
              placeholder={intl.formatMessage({
                id: "orientation",
              })}
              options={[
                {
                  id: 1,
                  value: 1,
                  name: "landscape",
                  i18n: true,
                },
                {
                  id: 2,
                  value: 2,
                  name: "portrait",
                  i18n: true,
                },
              ]}
              required
              validate={Validations.composeValidators(Validations.required)}
            />
          </div>
        </div>
      </Section>
      <Section title="template">
        <div className="grid">
          <div className="col-12 md:col-6 lg:col-4">
            <FileUpload
              infoMessages={[
                intl.formatMessage({
                  id: `upload_type_info_image`,
                }),
                intl.formatMessage(
                  {
                    id: `upload_file_dimensions`,
                  },
                  {
                    width: formState?.values?.orientation === 1 ? 842 : 1787,
                    height: formState?.values?.orientation === 1 ? 595 : 2526,
                  }
                ),
              ]}
              name="template"
              label="certificate_template"
              fileType={GlobalConstants.IMAGE_UPLOAD_FILE_TYPES}
              isImage
              uploading={uploading?.[templateFileName]}
              progress={progress?.[templateFileName] || 0}
              onUpload={onTemplateUpload}
              uploadDetails={uploadDetails?.[templateFileName]}
              onClear={onClear}
            />
          </div>
        </div>
      </Section>
    </div>
  );
};

const mapStateToProps = (state) => ({
  uploading: state?.uploads?.uploading,
  progress: state?.uploads?.progress,
});

export default connect(mapStateToProps)(CertificateDetailForm);
